export const PUBLIC_MENU_SETTING_KEY = "header_navigation";

export interface PublicMenuItem {
  id: string;
  label: string;
  href: string;
}

export interface PublicMenuConfig {
  items: PublicMenuItem[];
}

export function validatePublicMenuConfig(value: unknown): string | null {
  if (!value || typeof value !== "object" || !Array.isArray((value as PublicMenuConfig).items)) {
    return "Il menu deve contenere un elenco di voci.";
  }

  const items = (value as PublicMenuConfig).items;
  const ids = new Set<string>();
  const hrefs = new Set<string>();

  for (let index = 0; index < items.length; index += 1) {
    const item = items[index];
    if (!item || typeof item !== "object") return `La voce ${index + 1} non è valida.`;
    if (typeof item.id !== "string" || !/^[a-z0-9][a-z0-9-]{0,49}$/.test(item.id)) {
      return `La voce ${index + 1} deve avere un identificativo valido.`;
    }
    if (ids.has(item.id)) return `Identificativo duplicato: ${item.id}.`;
    ids.add(item.id);

    if (typeof item.label !== "string" || !item.label.trim() || item.label.trim().length > 60) {
      return `La voce ${index + 1} deve avere un'etichetta da 1 a 60 caratteri.`;
    }
    if (
      typeof item.href !== "string" ||
      !item.href.startsWith("/") ||
      item.href.startsWith("//") ||
      /[\s\\\u0000-\u001f]/.test(item.href) ||
      item.href.length > 256
    ) {
      return `Il link della voce ${index + 1} deve essere un percorso interno valido.`;
    }
    if (hrefs.has(item.href)) return `Link duplicato: ${item.href}.`;
    hrefs.add(item.href);
  }

  return null;
}

export function parsePublicMenuConfig(value?: string | null): PublicMenuItem[] {
  if (!value) return [];
  try {
    const parsed: unknown = JSON.parse(value);
    if (validatePublicMenuConfig(parsed)) return [];
    return (parsed as PublicMenuConfig).items.map((item) => ({
      id: item.id,
      label: item.label.trim(),
      href: item.href,
    }));
  } catch {
    return [];
  }
}

export function isPublicMenuItemActive(item: PublicMenuItem, pathname: string): boolean {
  if (item.href === "/") return pathname === "/";
  return pathname === item.href || pathname.startsWith(`${item.href.replace(/\/$/, "")}/`);
}